(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1358],{

/***/ 79360:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/validator",
      function () {
        return __webpack_require__(82646);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Button = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme, _type = param.type, type = _type === void 0 ? "default" : _type, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex cursor-pointer select-none items-center justify-center rounded-full ".concat(theme === "dark" ? "".concat(type === "outline" ? "border-[2px] border-[#292939] text-[#292939] hover:bg-[#292939] hover:text-white" : "bg-[#292939] text-white hover:bg-[#292939]/90") : "".concat(type === "outline" ? "border-[2px] border-primary text-primary hover:opacity-80" : "bg-primary text-white hover:bg-primary/90"), " h-[56px]  w-[242px] text-sm transition-all  ").concat(className),
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 82646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_div_100vh__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66409);
/* harmony import */ var _components_common_Nav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27356);
/* harmony import */ var _components_common_PageHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47270);
/* harmony import */ var _components_homepage_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70548);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






var benefits = [
    {
        name: "Token",
        icon: "/assets/network/validator-benefits-1.png"
    },
    {
        name: "Community",
        icon: "/assets/network/validator-benefits-2.png"
    },
    {
        name: "Karats",
        icon: "/assets/network/validator-benefits-3.png"
    }, 
];
var plans = [
    {
        date: "March",
        desc: "Karat met some great people in ETH Denver!\n    She gathered all the warriors that applied to fight for the project and she gave out honorary medals for the best mates.",
        icon: "/assets/network/validator-plan-march.png"
    },
    {
        date: "April",
        desc: "Karat find her friends who end up helping her spreading the callout for her big rocket project!\n    Kucoin, OKX, Bitmart and other friends will start actions immediately to support.",
        icon: "/assets/network/validator-plan-april.png"
    },
    {
        date: "May",
        desc: "Collect the boarding pass by verifying and claiming your Karat ID. \n          Get ready for the launch!",
        icon: "/assets/network/validator-plan-may.png"
    }, 
];
var Page = function() {
    var height = (0,react_div_100vh__WEBPACK_IMPORTED_MODULE_1__/* .use100vh */ .g)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var textStyle = {
        background: "linear-gradient(68.25deg, #6663F6 -2.3%, #EF8437 77.06%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        id: "container",
        className: "w-screen overflow-x-hidden overflow-y-scroll text-base bg-white font-exo",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_PageHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Nav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-validatorHeroBg bg-cover pt-16 sm:pt-[118px] px-6 sm:px-20 pb-20 sm:pb-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative bg-cover rounded-lg bg-validatorHeroBg1 sm:rounded-xl",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/assets/network/validator-rabbit.png",
                                className: "hidden sm:block w-[43%] -mt-[40px] "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-center justify-center p-5 sm:p-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-center selection:text-fill-white font-extrabold text-3xl sm:text-[56px] leading-tight z-10",
                                        style: {
                                            background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                            backgroundClip: "text",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                        },
                                        children: "Become a Validator"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-4 text-center max-w-[445px]",
                                        children: [
                                            "Buy a pass to become a validator in the KARAT network. As a validator, you’ll be an early contributor and pioneer to the network with very important functions.",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center gap-10 sm:gap-[72px] mt-12",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[22px] sm:text-[36px] text-dark1 font-extrabold",
                                                        children: "0.2ETH"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[14px] sm:text-[20px] font-medium mt-3",
                                                        children: "Mint price"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[22px] sm:text-[36px] text-dark1 font-extrabold",
                                                        children: "300"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[14px] sm:text-[20px] font-medium mt-3",
                                                        children: "Supply"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[22px] sm:text-[36px] text-dark1 font-extrabold",
                                                        children: "05/04"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[14px] sm:text-[20px] font-medium mt-3",
                                                        children: "Mint date"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_homepage_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        onClick: function() {
                                            router.push("/mint/validator");
                                        },
                                        className: "mt-12 font-semibold",
                                        children: "Mint"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center mt-[20px] sm:mt-[86px] px-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/network/validator-logo.png",
                        className: "max-w-[715px] w-full"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-8 font-medium text-dark1",
                        children: "Join those who have already onboarded"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative before:opacity-40 before:bg-blend before:bg-cover before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-[120px] sm:mt-[173px] px-5 sm:px-[120px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative max-w-[1200px] mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/assets/network/verifier-join-bg.png",
                                    className: "w-full h-[300px] sm:h-[443px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "selection:text-fill-white font-extrabold text-3xl sm:text-[48px] leading-tight z-10",
                                            style: {
                                                background: "linear-gradient(180deg, #87B5FF 0%, #ADB5FF 100%)",
                                                backgroundClip: "text",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent"
                                            },
                                            children: "Benefits"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex items-center gap-5 sm:gap-[80px] mt-5 sm:mt-10",
                                            children: benefits.map(function(item, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "w-[70px] h-[70px] sm:w-[196px] sm:h-[196px] flex items-center justify-center rounded-full",
                                                            style: {
                                                                background: "rgba(255, 255, 255, 0.2)",
                                                                backdropFilter: "blur(5.72px)"
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                className: "w-[60px] h-[60px] sm:w-[173px] sm:h-[173px]",
                                                                src: item.icon
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mt-6 font-medium text-white text:base sm:text-xl",
                                                            children: item.name
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-[120px] sm:mt-[228px] px-5 sm:px-[184px] pb-[257px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-[1200px] mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "selection:text-fill-white font-extrabold text-3xl sm:text-[48px] leading-tight z-10",
                                    style: {
                                        background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                        backgroundClip: "text",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent"
                                    },
                                    children: "Our next plans"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid grid-cols-1 sm:grid-cols-3 gap-[180px] sm:gap-[55px] mt-12",
                                    children: plans.map(function(plan, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "bg-[#FCFCFF] px-7 pt-[50px] pb-[143px] border-gradient",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[32px] text-dark1 font-semibold",
                                                    children: plan.date
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-4 whitespace-pre-line",
                                                    children: plan.desc
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute -bottom-[130px] left-0 w-full flex justify-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "w-[90%] max-w-[250px]",
                                                        src: plan.icon
                                                    })
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7258,4304,7172,2256,7356,9774,2888,179], function() { return __webpack_exec__(79360); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);